var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.592 25.5367C23.1057 11.7433 32.9903 -0.411835 48.9773 8.77065C57.3848 13.5997 73.4946 27.993 77.7594 42.3077C84.2969 53.7152 74.7099 65.6992 70.4461 73.0462C61.4528 88.5428 42.5396 80.7774 26.5525 71.5949C10.5655 62.4124 2.5986 41.0333 11.592 25.5367Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.206 15.907C46.9593 15.241 23.3403 22.1615 22.3528 23.1023C21.1184 24.2783 20.4334 26.7159 20.795 28.5913C21.1567 30.4667 30.4443 67.4944 31.6074 68.9437C32.7705 70.3931 34.1028 74.0511 38.0985 73.1918C42.0942 72.3325 59.7185 67.3987 61.0985 67.029C62.4785 66.6592 64.4392 64.5137 64.2218 62.3883C64.0045 60.263 53.3566 21.8388 52.8635 19.9986",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4824 62.2245C39.1095 61.8212 55.6683 57.3867 56.4504 56.7061C57.428 55.8554 58.0068 54.1303 57.7657 52.8211C57.5245 51.5119 51.1034 25.7077 50.2344 24.7139C49.3653 23.7202 48.4106 21.1794 45.3062 21.864C42.2019 22.5486 28.4859 26.371 27.4123 26.6587C26.3386 26.9464 24.7802 28.4924 24.9048 29.98C25.0295 31.4676 32.4729 58.2245 32.8164 59.5062",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2305 66.0254C45.0564 65.3996 52.7228 63.9046 52.7812 62.9304",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8423 18.025C75.8425 26.31 65.1851 30.2985 57.0151 30.2983C48.8451 30.2982 46.2564 26.3093 46.2562 18.0243C46.256 9.73936 56.5772 2.68238 64.7471 2.68258C72.9171 2.68277 75.8421 9.74007 75.8423 18.025Z",
    fill: "#EF533F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1309 16.8107C56.2158 18.1222 58.5301 20.6796 59.1087 20.4173C59.8319 20.0895 63.8095 14.8437 65.9791 13.5322",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H88V88H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.851897aac41615fe856e084c6cfe971b.svg";
export { ForwardRef as ReactComponent };